function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import useData from '../../data';
import EventsSectionDescription from '../EventsSectionDescription';
import MdPlayCircleOutline from '@meronex/icons/md/MdPlayCircleOutline';
import ReactPlayer from 'react-player/youtube';
import CommonUI from './CommonUI';
import { useHistory } from 'react-router-dom';
import { LoadingSpinner, ProjectGridLoadingUI } from '../../../Common/LoadingUI';
import { loadMoreSvg } from '../../../DealsAndDiscounts/Components/ProductListing/svg';
import Container from '../../../Projects/Components/Container';
import { isDosti } from '../../../../utils/isClient';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function EventsLayout2(_ref) {
  var _window$reloy_env$cli, _window$reloy_env$cli2;
  var config = _ref.config,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient,
    isAuthenticated = _ref.isAuthenticated,
    theme = _ref.theme,
    ThemeProvider = _ref.ThemeProvider,
    ComponentsRenderer = _ref.ComponentsRenderer,
    FilterOptions = _ref.FilterOptions,
    onNavigateToDetail = _ref.onNavigateToDetail;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    playVideo = _useState2[0],
    setPlayVideo = _useState2[1];
  var _useData = useData({
      isPast: true,
      checkProtectedEvents: false,
      winnreAuth: winnreAuth,
      cmsClient: cmsClient,
      config: config
    }),
    pastEvents = _useData.events,
    isLoading = _useData.isLoading,
    currentPage = _useData.currentPage,
    setCurrentPage = _useData.setCurrentPage,
    totalPages = _useData.totalPages,
    loadMoreHandler = _useData.loadMoreHandler,
    onFilterClick = _useData.onFilterClick,
    selectedCategories = _useData.selectedCategories;
  var history = useHistory();
  // console.log("pastEvents" , pastEvents);
  var galleryIntent = function galleryIntent(eventId, title, category, date) {
    var _window;
    // console.log(eventId, title, category, date);
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track('EventViewed', {
      EventName: title,
      EventType: category,
      Timestamp: date
    });
    history.push("/events/".concat(eventId));
  };
  var showAppDownload = ((_window$reloy_env$cli = window.reloy_env.client_config.MY_PROFILE) === null || _window$reloy_env$cli === void 0 ? void 0 : _window$reloy_env$cli.PLAY_STORE_LINK) || ((_window$reloy_env$cli2 = window.reloy_env.client_config.MY_PROFILE) === null || _window$reloy_env$cli2 === void 0 ? void 0 : _window$reloy_env$cli2.APP_STORE_LINK);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: (pastEvents.length > 0 || selectedCategories.length > 0) && /*#__PURE__*/_jsxs(Container, {
      className: " min-h-screen ".concat(showAppDownload ? 'pb-20' : '', " "),
      config: config,
      children: [/*#__PURE__*/_jsx(EventsSectionDescription, {
        pastEvents: pastEvents,
        selectedCategories: selectedCategories,
        onFilterClick: onFilterClick,
        type: "EVENT",
        config: config,
        color: "black",
        ComponentsRenderer: ComponentsRenderer
      }), /*#__PURE__*/_jsx("div", {
        className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 px-10 md:px-20 lg:px-2 xl:px-20 2xl:px-48 3xl:px-48 h-full w-full md:gap-x-8 lg:gap-x-4 2xl:gap-x-4 3xl:gap-7 gap-y-10 pb-7 pt-16  ",
        children: pastEvents.map(function (event) {
          if (event !== null && event !== void 0 && event.videoUrl) {
            return /*#__PURE__*/_jsxs("div", {
              className: "relative min-h-72 3xl:min-h-[350px] shadow-lg hover:shadow-xl border-info border-b-2 cursor-pointer ".concat(config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : ''),
              onClick: function onClick() {
                return galleryIntent(event === null || event === void 0 ? void 0 : event.id, event === null || event === void 0 ? void 0 : event.title, event === null || event === void 0 ? void 0 : event.tags[0].name, event === null || event === void 0 ? void 0 : event.startDate);
              },
              children: [/*#__PURE__*/_jsx("div", {
                className: "".concat(isDosti(config) ? 'h-auto' : 'h-44 3xl:h-56'),
                children: /*#__PURE__*/_jsx(ReactPlayer, {
                  url: event === null || event === void 0 ? void 0 : event.videoUrl,
                  className: "react-player  fixed-bottom self-center",
                  playIcon: /*#__PURE__*/_jsxs("div", {
                    className: "flex relative w-full h-full justify-center",
                    children: [/*#__PURE__*/_jsx("img", {
                      className: "object-cover self-center h-full w-full ",
                      src: event === null || event === void 0 ? void 0 : event.displayImageUrl
                    }), /*#__PURE__*/_jsx(MdPlayCircleOutline, {
                      className: " absolute self-center text-white text-9xl "
                    })]
                  }),
                  playing: playVideo,
                  light: true,
                  onClickPreview: function onClickPreview() {
                    setPlayVideo(true);
                  },
                  width: "100%",
                  height: "100%",
                  controls: true
                })
              }), /*#__PURE__*/_jsx(CommonUI, {
                eventDate: event === null || event === void 0 ? void 0 : event.startDate,
                eventHost: event === null || event === void 0 ? void 0 : event.eventHost,
                title: event === null || event === void 0 ? void 0 : event.title,
                config: config
              })]
            });
          }
          if (event !== null && event !== void 0 && event.plainBannerImageUrl) {
            return /*#__PURE__*/_jsxs("div", {
              onClick: function onClick() {
                return galleryIntent(event === null || event === void 0 ? void 0 : event.id, event === null || event === void 0 ? void 0 : event.title, event === null || event === void 0 ? void 0 : event.tags[0].name, event === null || event === void 0 ? void 0 : event.startDate);
              },
              className: " relative min-h-72 3xl:min-h-[320px] shadow-lg hover:shadow-xl border-info border-b-2 cursor-pointer ".concat(config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : ''),
              children: [/*#__PURE__*/_jsx("div", {
                className: "".concat(isDosti(config) ? 'h-auto' : 'h-44 3xl:h-56'),
                children: /*#__PURE__*/_jsx("img", {
                  src: event !== null && event !== void 0 && event.plainBannerImageUrl ? event === null || event === void 0 ? void 0 : event.plainBannerImageUrl : 'https://srijanprod.s3.ap-south-1.amazonaws.com/Website/Uploads/Srijan/Images/54304473.jpg',
                  className: "w-full h-full object-cover"
                })
              }), /*#__PURE__*/_jsx(CommonUI, {
                eventDate: event === null || event === void 0 ? void 0 : event.endDate,
                eventHost: event === null || event === void 0 ? void 0 : event.eventHost,
                title: event === null || event === void 0 ? void 0 : event.title,
                config: config
              })]
            });
          }
        })
      }), !isLoading && currentPage < totalPages && /*#__PURE__*/_jsx("div", {
        className: " flex justify-center pb-7 ",
        children: /*#__PURE__*/_jsx("button", {
          onClick: loadMoreHandler,
          className: "flex items-center justify-center gap-x-2 mx-auto px-4 py-2 text-[#908F95] border-[3px] border-[#DDDDDD] rounded mb-6",
          children: /*#__PURE__*/_jsxs(_Fragment, {
            children: ["Load More", loadMoreSvg]
          })
        })
      })]
    })
  });
}
export default EventsLayout2;